import { SpinnerWheel } from '@loadsmart/miranda-react'

import { StyledContainer } from './Fallback.style'

export default function Fallback() {
  return (
    <StyledContainer>
      <SpinnerWheel size="48px" />
    </StyledContainer>
  )
}
